import React from "react";
import { Helmet } from "react-helmet-async";
import Navbar from "../Components/Navbar/Navbar";
import ProductCard from "../Components/ProductCard/ProductCard";
import Footer from "../Components/Footer/Footer";
import { Box } from "@mui/material";
import CardImg from "../Assets/chicken_hot_bake_single.png";
import useMetaTracking from "../hooks/useMetaTracking";

function ChickenHotBake() {
  useMetaTracking("ViewContent", {
    content_name: "Chicken Hot Bake",
    content_category: "Regular Menu",
    content_ids: ["chicken_hot_bake"],
    content_type: "pastries",
    value: 3.00,
    currency: "USD",
  });

  return (
    <>
      <Helmet>
        <title>Chicken Hot Bake | Đông Hưng Viên Bakery</title>
        <meta
          name="description"
          content="Delicious puff pastry pockets filled with shredded grilled chicken & cheese."
        />
        <meta
          property="og:title"
          content="Chicken Hot Bake | Đông Hưng Viên Bakery"
        />
        <meta
          property="og:description"
          content="Delicious puff pastry pockets filled with shredded grilled chicken & cheese."
        />
      </Helmet>
      <Box className="product-page" sx={{ pt: 10, background: "#0f0f0f" }}>
        <Navbar />
        <ProductCard
          cardImg={CardImg}
          titleHead="CHICKEN HOT BAKE"
          titleSubHead="$3.00 each"
          detailBody="Delicious puff pastry pockets filled with shredded grilled chicken & cheese. A feel-good snack that fits your schedule & your appetite."
          detailBodyBr="Contains: wheat, dairy, egg"
          detailBody3="Available now!"
          ProductCardBtn="View Full Regular Menu"
          btnLink="/regular-menu"
        />
        <Footer />
      </Box>
    </>
  );
}

export default ChickenHotBake;